export enum DocResourceStatus{
	DRAFT = 'DRAFT',
	PUBLISHED = 'PUBLISHED',
	OBSOLETE = 'OBSOLETE',
}
